import { MijnRoute } from '../../mijn-navigatie.model';

export const INVESTMENT_FINANCIAL_RETURN: MijnRoute = {
    path: ':id/financieel-rendement',
    navigationEvent: 'toFinancialReturn',
    regex: /^\/beleggen\/[^/]+\/financieel-rendement$/,
    webcomponent: 'mijn-beleggen-portfolio-webcomponent',
    internalPath: ':id/financieel-rendement'
};
